import React, { useEffect, useState } from "react";
import { useDrawerProvider } from "../../providers/DrawerProvider";
import { useUserProvider } from "../../providers/UserProvider";
import { useOnboardingProvider } from "../../providers/OnboardingProvider";
import SlideOut from "../SlideOut";
import { GetApp } from "../../services/api/app";
import { useCallback } from "react";

const BuildAndSubmitSlideOutButton = ({ title, type, btnLabel }) => {
  const { showDrawer, closeDrawer } = useDrawerProvider();
  const { user, setUser } = useUserProvider();
  const { refetchCounter, onboardingData } = useOnboardingProvider();
  const [initialValues, setInitialValues] = useState({
    ...user,
    onboarding: onboardingData
  });

  const handleGetApp = useCallback(() => {
    GetApp(user, user.idToken).then((res) => res.json()).then((res) => {
      setUser({
        ...user,
        app_data: {
          ...res?.data,
          username: res.data.username,
        },
      });

      setInitialValues({
        ...user,
        app_data: {
          ...res?.data,
          username: res.data.username,
        },
        onboarding: res?.data?.onboarding
      });
    })
  }, [])

  useEffect(() => {
    handleGetApp()
  }, [refetchCounter])

  return (
    <button
      className={`ttnk-button text-white bg-darkGray text-2xl`}
      style={{ backgroundImage: "none", width: 128 }}
      type="submit"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        showDrawer(
          <SlideOut
            type={type}
            showSubmitBtn={false}
            handleSubmit={closeDrawer}
            data={initialValues}
          />,
          title,
          "50vw",
          "text-center w-full",
          true
        );
      }}
    >
      {btnLabel}
    </button>
  )
}

export default BuildAndSubmitSlideOutButton;